import React from 'react';
import { getConfig } from 'config/runtime';

const IMAGE_BASE_URL = getConfig('REACT_APP_IMAGES');

const DriverData = ({ driverData }) => {
  return (
    <div className="detail-driver-data">
      <div className="driver">
        <div className="image">
          {driverData?.PersonalInfos?.selfie ? (
            <img src={`${IMAGE_BASE_URL}${driverData.PersonalInfos.selfie}`} alt="driver" />
          ) : (
            <img src="/assets/image/dummy-driver-image.png" alt="driver" />
          )}
        </div>
        <div className="data">
          <h3>{driverData?.name}</h3>
          <p>{driverData?.wa_number || driverData?.phone}</p>
          <p>
            {driverData?.vehicle?.brand_name && <span>{driverData?.vehicle?.brand_name} </span>}
            <span>{driverData?.vehicle?.name}</span> · <span>{driverData?.vehicle?.license_number}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DriverData;
